/**
 * İzin sözleşmesi.
 *
 * UYARI: Buradaki fonksiyonlar **arayüz gizleme** içindir; güvenlik sınırı
 * değildir. Bir düğmeyi gizlemek, ilgili endpoint'i korumaz. Her endpoint
 * sunucu tarafında policy ile korunur ve her rol için **reddedilme testi**
 * yazılır (bkz. docs/standards/security-standard.md).
 *
 * ## Rol → izin eşlemesi burada TUTULMAZ
 *
 * Bu dosya önce rolleri ve her rolün izinlerini elle tanımlıyordu. O tasarım
 * aynı kararı iki yerde tanımlar ve ikisi kaçınılmaz olarak ayrışır:
 * backend'e yeni bir izin eklenir, arayüz eski listeyle çalışmaya devam eder
 * ve kullanıcıya var olmayan düğmeler gösterilir ya da hakkı olan menü
 * gizlenir. İlk sürümdeki 13 iznin **hiçbiri** backend'de mevcut değildi;
 * ayrışma teorik değil, ilk günden gerçekti.
 *
 * Artık **etkin izinler sunucudan gelir** (`GET /api/v1/session`). Arayüz
 * yalnızca listede olup olmadığına bakar; hangi rolün hangi izni verdiğini
 * bilmesi gerekmez.
 */

/**
 * İzin kodu — `<bağlam>.<eylem>`.
 *
 * Kasıtlı olarak `string`: katalog sunucuya aittir ve burada sabitlemek,
 * az önce kaldırılan ayrışmayı geri getirir.
 */
export type Permission = string

/** Sunucudan gelen oturum izinleri. */
export interface PermissionSet {
  readonly permissions: readonly Permission[]
}

/**
 * Oturumun bu izni var mı?
 *
 * Bilinmeyen bir izin adı `false` döndürür — arayüz öğesi gizlenir. Ters
 * varsayılan (bilinmiyorsa göster) bir yazım hatasında kullanıcıya
 * çalışmayan bir düğme gösterirdi.
 */
export function hasPermission(session: PermissionSet, permission: Permission): boolean {
  return session.permissions.includes(permission)
}

/** Verilen izinlerden **herhangi biri** var mı? */
export function hasAnyPermission(
  session: PermissionSet,
  permissions: readonly Permission[],
): boolean {
  return permissions.some((permission) => hasPermission(session, permission))
}

/** Verilen izinlerin **tamamı** var mı? */
export function hasAllPermissions(
  session: PermissionSet,
  permissions: readonly Permission[],
): boolean {
  return permissions.every((permission) => hasPermission(session, permission))
}
